import type { ContractType } from "../types/enums";
import type { Skill, Tool } from "../types";

export function suitableToolsForType(
  type: ContractType,
  owned: readonly string[],
  allTools: readonly Tool[],
): Tool[] {
  return allTools.filter((t) => owned.includes(t.id) && t.category === type);
}

export function suitableSkillsForType(
  type: ContractType,
  skills: Record<string, number>,
  allSkills: readonly Skill[],
): Skill[] {
  return allSkills.filter((s) => (skills[s.id] ?? 0) > 0 && s.category === type);
}
